export enum MODAL {
  APP_INFO = 'appInfo',
  SEARCH = 'search',
  SETTINGS = 'settings',
  USER = 'user',
}

export enum CURSOR {
  POINTER = 'pointer',
  LOGO = 'logo',
  GO = 'go',
  EXPANSE = 'expanse',
  SCAN = 'scan',
  PLAY = 'play',
  LENS = 'lens',
}

export interface IMousePosition {
  clientX: number
  clientY: number
}

export interface IUiState {
  isDark: boolean
  setIsDark: (dark: boolean) => void
  onToggleIsDark: () => void
  cursor: CURSOR | undefined
  setCursor: (cursor: CURSOR | undefined) => void
  mousePosition: IMousePosition
  setMousePosition: (mouse: IMousePosition) => void
  modal: MODAL | undefined
  onToggleModal: (modal: MODAL) => void
  onClearModal: () => void
}
